import platformsJson from "../../data/performanceMarketingPlatforms.json";

export default function Section4() {
  const platformsData = platformsJson;

  return (
    <div className="Section4">
      <div className="section4-container">
        <div className="md:w-[61%] my-[24px] mx-5 md:my-0 md:mx-auto text-center">
          <h2 className="text-[24px] md:text-[34px] font-bold leading-[32px] md:leading-[41px] text-[#151515] mt-[40px]">
            Our Advertising Platforms
          </h2>
        </div>

        <div className="flex boxes p-[2%_0%_1%_0%] justify-center gap-y-[19px] md:gap-y-[30px] gap-x-[2%] w-[85%] xs:w-full md:w-[85%] mx-auto flex-wrap">
          {platformsData.map(({ imgUrl, title }, index) => {
            return (
              <div
                key={title + index}
                className="bg-[#f5f5f5] w-full xs:w-[40%] p-[10%] xs:p-[4%] md:p-[3%] text-center md:w-[30%] min-[1150px]:w-[13%]"
              >
                <img
                  src={imgUrl}
                  className="mx-auto w-[25%] md:w-[30%] min-[1150px]:w-[50%]"
                ></img>
                <h3 className="text-[18px] font-bold leading-[20px] text-[#888888] mt-5 mb-[10px]">
                  {title}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
